import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import EftWithdrawTransactionInfo from './EftWithdrawTransactionInfo';
import useFetchEFTWithdrawTransaction from '@/hooks/useApi/useFetchEFTWithdrawTransaction';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

type EftWithdrawTransactionProps = {
  TransactionID: string;
  Notes: string;
};

type FC = FunctionComponent<EftWithdrawTransactionProps>;

const EftWithdrawTransactionContainer: FC = (props: EftWithdrawTransactionProps) => {
  const { TransactionID, Notes } = props;
  const { userSettings } = useUserSettingsProvider();
  const [eftWithdrawTransaction, getEftWithdrawTransaction] = useFetchEFTWithdrawTransaction({ bearer: '' });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.EftWithdrawTransactionResponse>();

  useEffect(() => {
    getEftWithdrawTransaction({ TransactionID, Timezone: userSettings.timezone });
  }, [currentTransactionId, TransactionID]);

  useEffect(() => {
    if (eftWithdrawTransaction) {
      setTransaction(eftWithdrawTransaction);
    }
  }, [eftWithdrawTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <EftWithdrawTransactionInfo transaction={transaction} Notes={Notes} />}</div>;
};

export default EftWithdrawTransactionContainer;
